import { CascadiaIllustration } from "@certn/cascadia-tokens";

import { CheckProcessingIllustration } from "./assets/CheckProcessingIlllustration";
import { CheckSuccessIllustration } from "./assets/CheckSuccessIllustration";
import { CheckTodoIllustration } from "./assets/CheckTodoIllustration";
import { MessagesIllustration } from "./assets/MessagesIllustration";
import { NfcDocumentIllustration } from "./assets/NfcDocumentIllustration";
import { NoResultsIllustration } from "./assets/NoResultsIllustration";
import { NotificationsIllustration } from "./assets/NotificationsIllustration";
import { OneIDFailIllustration } from "./assets/OneIDFailIllustration";
import { OneIDSuccessIllustration } from "./assets/OneIDSuccessIllustration";
import { RewardsIllustration } from "./assets/RewardsIllustration";
import { SparklesIllustration } from "./assets/SparklesIllustration";
import { SuccessIllustration } from "./assets/SuccessIllustration";
import { VerificationFailIllustration } from "./assets/VerificationFailIllustration";
import { VerificationSuccessIllustration } from "./assets/VerificationSuccessIllustration";
import { WalletCardsIllustration } from "./assets/WalletCardsIllustration";

export interface IllustrationProps {
  size?: number;
  height?: number;
  name: CascadiaIllustration;
  className?: string;
}

export function Illustration(props: IllustrationProps) {
  const { name, size = 88, height = size, ...svgProps } = props;

  const illustrationProps = {
    width: size,
    height,
    ...svgProps,
  };

  switch (name) {
    case "success":
      return <SuccessIllustration {...illustrationProps} />;
    case "check-processing":
      return <CheckProcessingIllustration {...illustrationProps} />;
    case "check-todo":
      return <CheckTodoIllustration {...illustrationProps} />;
    case "wallet-cards":
      return <WalletCardsIllustration {...illustrationProps} />;
    case "notifications":
      return <NotificationsIllustration {...illustrationProps} />;
    case "messages":
      return <MessagesIllustration {...illustrationProps} />;
    case "check-success":
      return <CheckSuccessIllustration {...illustrationProps} />;
    case "oneid-fail":
      return <OneIDFailIllustration {...illustrationProps} />;
    case "oneid-success":
      return <OneIDSuccessIllustration {...illustrationProps} />;
    case "rewards":
      return <RewardsIllustration {...illustrationProps} />;
    case "no-results":
      return <NoResultsIllustration {...illustrationProps} />;
    case "sparkles":
      return <SparklesIllustration {...illustrationProps} />;
    case "verification-success":
      return <VerificationSuccessIllustration {...illustrationProps} />;
    case "verification-fail":
      return <VerificationFailIllustration {...illustrationProps} />;
    case "nfc-document":
      return <NfcDocumentIllustration {...illustrationProps} />;
  }
}
